import React from 'react'
import PropTypes from 'prop-types'
import { Label, Input, FormGroup, Button } from 'reactstrap'
import styled from 'styled-components'
import $ from 'jquery'

import { Icon } from 'react-icons-kit'
import { youtube } from 'react-icons-kit/feather/youtube'
import { camera } from 'react-icons-kit/feather/camera'
import { mic } from 'react-icons-kit/feather/mic'

const SIcon = styled(Icon)`
  margin-right: 5px;
`
const Span = styled.span`
  display: inline-block;
  position: absolute;
  overflow: visible;
  white-space: nowrap;
  font-size: 0.1em;
  color: red;
  text-align: center;
  padding: 0 8px;
  margin-top: -3px;
  text-transform: uppercase;
  line-height: 1.5;
  &:before{
    display: block;
    margin-left: 2px;
    content: '';
    width: 10px;
    height: 10px;
    background: red;
    border-radius: 50%;
  }

`

class PartTypeForm extends React.Component {
  constructor(props, ...rest) {
    super(props, ...rest)
    this.state = {}
  }
  setType(newtype) {
    const { handleOnChange, partIndex } = this.props
    const e = { target: { id: 'type', value: newtype } }
    handleOnChange(e, partIndex)
    setTimeout(() => {
      $(`.part-content-${partIndex}`).find('input[type=file]').click()
    }, 250)
  }

  render() {
    const { handleOnChange, partIndex, value } = this.props
    return (
      <div>
        <h6>Contenus Live <Span>rec</Span></h6>
        <Button block color="primary" size="lg" outline onClick={() => { this.setType('Audio') }}> <SIcon icon={mic} /> Audio</Button>
        <Button block color="danger" size="lg" outline onClick={() => { this.setType('Video') }}> <SIcon icon={youtube} /> Video</Button>
        <Button block color="info" size="lg" outline onClick={() => { this.setType('Picture') }}> <SIcon icon={camera} /> Photo</Button>
        <br />
        <FormGroup>
          <Label htmlFor={`type-${partIndex}`}>Tous les contenus</Label>
          <Input
            type="select"
            name={`type-${partIndex}`}
            id="type"
            value={value}
            onChange={e => (handleOnChange(e, partIndex))}
          >
            <option value="">Choisir un type</option>
            <option value="Button">Bouton d'action</option>
            <option value="Text">Texte</option>
            <option value="Picture">Image - téléverser</option>
            <option value="PictureUrl">Image - url</option>
            <option value="Video">Vidéo - téléverser</option>
            <option value="VideoYoutube">Vidéo Youtube</option>
            <option value="Audio">Audio - téléverser</option>
            <option value="Redirect">Redirect</option>
          </Input>
        </FormGroup>
      </div>
    )
  }
}


PartTypeForm.defaultProps = {
  value: ''
}
PartTypeForm.propTypes = {
  handleOnChange: PropTypes.func.isRequired,
  partIndex: PropTypes.number.isRequired,
  value: PropTypes.string
}

export default PartTypeForm






// WEBPACK FOOTER //
// ./src/components/PartTypeForm/index.js